import { Draggable, DraggableProvided } from "@hello-pangea/dnd"
import { ReactElement } from "react";
import { Item } from ".";

const DragItem = ({ model: Model, getItemStyle, click, children, itemOfList, index }: {
    itemOfList: {
        id: string;
        label?: string | undefined;
    }
    click: ((payload: {
        id: string;
        index: number;
        item: Item;
    }) => void) | undefined
    index: number
    children?: JSX.Element
    model?: ((payload: {
        item: Item;
        provided: DraggableProvided;
        index: number;
    }) => ReactElement)
    getItemStyle: (_: boolean, draggableStyle?: any) => any
}) => {
    if (!itemOfList?.id) return <></>
    return (
        <Draggable key={itemOfList?.id} draggableId={itemOfList?.id} index={index}>
            {(provided, snapshot) => (
                children ? <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={getItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                    )}
                >{children}
                    <button onClick={() => {
                        if (click) {
                            click({ id: itemOfList?.id, index, item: itemOfList })
                        }
                    }} >click</button>
                </div> : (
                    Model ?
                        Model({ item: itemOfList, provided, index })
                        :
                        (
                            <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style
                                )}
                            >
                               <p>{itemOfList.label}</p>
                            </div>
                        )

                )
            )}
        </Draggable>
    )
}


export { DragItem }